import { useParams } from "react-router-dom";
import { useQuery } from "../../utils/hooks";
import ConsentPreview from "./Builder/ConsentPreview/ConsentPreview";

const RegistryConsentPreview = () => {
  const { formId } = useParams();
  const versionId = useQuery().get("versionId") || "";

  return (
    <ConsentPreview
      studyId={""}
      formId={formId || ""}
      versionId={versionId}
      type="platform"
      editable={true}
    />
  );
};

export default RegistryConsentPreview;
